import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { capitalize } from "lodash";
import { AS } from "../AirfoilStyles/index.js";
import { cn as clsx } from "../../helpers/react.js";
const getKeyByProps = (props) => {
  if (props.type === "heading") {
    return `workSansHeading${props.size.toString()}`;
  } else if (props.type === "numerical") {
    return `nkduyMonoNumerical${props.size}${capitalize(props.weight)}`;
  } else if (props.type === "text") {
    return `workSans${props.size}${capitalize(props.weight)}`;
  } else {
    return `workSansUppercase${props.size}${capitalize(props.weight)}`;
  }
};
const Font = forwardRef((props, ref) => {
  const { children } = props;
  const className = AS.getTypographyClassName(getKeyByProps(props));
  return /* @__PURE__ */ jsx(Slot, { ref, className: clsx(className), children });
});
export {
  Font
};
